export default __webpack_public_path__ + "static/media/avatar-1.32658e3a.png";